/* ODAVIA – Produktgalerie auf Desktop: Pfeile links/rechts, Ziehen mit der Maus,
   Pfeiltasten. Nutzt die vorhandenen Thumbnails des Themes (Klick auf den
   nächsten Thumbnail), damit Bildwechsel, Zähler und Zoom-Modal konsistent bleiben. */
(function () {
  if (window.__odaviaGalleryNav) return;
  window.__odaviaGalleryNav = true;

  var mq = window.matchMedia('(min-width: 750px)');
  var CARET = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function init(gallery) {
    if (gallery.__gnav) return;
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
    var list = gallery.querySelector('.product__media-list');
    var thumbs = gallery.querySelector('.thumbnail-list');
    if (!viewer || !list || !thumbs) return;
    gallery.__gnav = true;

    function items() {
      return Array.prototype.slice.call(thumbs.querySelectorAll('.thumbnail-list__item')).filter(function (li) {
        return li.offsetParent !== null;
      });
    }
    function currentIndex() {
      var active = list.querySelector('.product__media-item.is-active');
      var arr = items();
      if (!active) return 0;
      for (var i = 0; i < arr.length; i++) if (arr[i].dataset.target === active.dataset.mediaId) return i;
      return 0;
    }
    function go(delta) {
      var arr = items();
      if (arr.length < 2) return;
      var n = (currentIndex() + delta + arr.length) % arr.length;
      var btn = arr[n].querySelector('button.thumbnail');
      if (btn) btn.click();
    }

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'odavia-gnav odavia-gnav--prev';
    prev.setAttribute('aria-label', 'Vorheriges Bild');
    prev.innerHTML = CARET;
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'odavia-gnav odavia-gnav--next';
    next.setAttribute('aria-label', 'Nächstes Bild');
    next.innerHTML = CARET;
    viewer.classList.add('odavia-has-nav');
    viewer.appendChild(prev);
    viewer.appendChild(next);
    prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); go(1); });

    // Ziehen mit der Maus
    var startX = null, moved = false;
    list.addEventListener('pointerdown', function (e) {
      if (!mq.matches || e.pointerType === 'touch' || e.button !== 0) return;
      startX = e.clientX; moved = false;
      list.classList.add('is-dragging');
    });
    list.addEventListener('pointermove', function (e) {
      if (startX === null) return;
      if (Math.abs(e.clientX - startX) > 8) moved = true;
    });
    function end(e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      startX = null;
      list.classList.remove('is-dragging');
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    }
    list.addEventListener('pointerup', end);
    list.addEventListener('pointerleave', end);
    list.addEventListener('pointercancel', function () { startX = null; list.classList.remove('is-dragging'); });
    // Nach einem Ziehen kein Zoom-Modal öffnen
    list.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    // Pfeiltasten, wenn die Galerie den Fokus hat oder die Maus darüber steht
    var hover = false;
    gallery.addEventListener('mouseenter', function () { hover = true; });
    gallery.addEventListener('mouseleave', function () { hover = false; });
    document.addEventListener('keydown', function (e) {
      if (!mq.matches || !(hover || gallery.contains(document.activeElement))) return;
      if (document.querySelector('product-modal[open]')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });

    function update() {
      var show = mq.matches && items().length > 1;
      prev.hidden = !show;
      next.hidden = !show;
    }
    update();
    if (mq.addEventListener) mq.addEventListener('change', update); else mq.addListener(update);
    document.addEventListener('shopify:section:load', update);
  }

  function scan() { document.querySelectorAll('media-gallery').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
